import { Component, forwardRef, Injector, ChangeDetectorRef, Inject } from '@angular/core';
import {
    ApiService,
    AuthenticateService,
    ConfigService,
    CookieService, EndpointService,
    LocalStorageService
} from '@angular/synthrone-design/services';

import {
    Router,
    Event as RouterEvent,
    NavigationStart,
    NavigationEnd,
    NavigationCancel
} from '@angular/router'
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    loading = true;
    somethingToSetup = true;

    private config;
    private api: ApiService;
    private endpointService: EndpointService;

    appSettingInfo = {
        message: '',
        progress: 0
    };

    constructor(private router: Router, private authenticateService: AuthenticateService, private cdr: ChangeDetectorRef,
                @Inject(forwardRef(() => CookieService)) private cookieService: CookieService,
                @Inject(forwardRef(() => LocalStorageService)) private lsService: LocalStorageService,
                @Inject(ConfigService) private configService,
                injector: Injector) {

        this.config = this.configService.getAppConfig();
        this.api = injector.get(ApiService);
        this.endpointService = injector.get(EndpointService);

        router.events.subscribe((event: RouterEvent) => {
            this.somethingToSetup = false;
            this.loading = false;
        });
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.somethingToSetup = this.authenticateService.shouldBasicBeSetUp('adminer');
            this.appSettingInfo.progress = 0;
            this.appSettingInfo.message = '';
            setTimeout(() => {
                const bs = this.basicSettingsLoad().subscribe((res) => {
                    this.somethingToSetup = false;
                    this.loading = false;
                    bs.unsubscribe();
                });
            })
        }
        if (event instanceof NavigationEnd) {
            if (!this.somethingToSetup) {
                this.loading = false;
            }
        }
        if (event instanceof NavigationCancel) {
            if (!this.somethingToSetup) {
                this.loading = false;
            }
        }
    }

    basicSettingsLoad = () => {
        const stages = 3;
        const settingsObserver = new Subject();

        if (this.router.url === '/maintenance') {
            setTimeout(() => {
                settingsObserver.next((new Date()));
            }, 2000);
            this.appSettingInfo.progress = 100;
            return settingsObserver;
        }

        const afterInitialized = () => {

            if (this.appSettingInfo) {
                this.appSettingInfo.message = 'Verifying application data';
                this.appSettingInfo.progress = Math.ceil(((1 / stages) * 100));
            }

            const getAppRoutes = (appNameInner, callback) => {
                let routes = {};

                if (this.config.hasOwnProperty('requestThisApplicationRoutes') && this.config.requestThisApplicationRoutes == false) {
                    routes[appNameInner] = [];
                    this.lsService.setItem('apiRoutes', routes, true);
                    callback();
                }

                routes = this.lsService.getItem('apiRoutes', true);
                if (routes && routes[appNameInner]) {
                    callback();
                } else {
                    this.endpointService.getRoutes(this.api, appNameInner).subscribe((routesCallback) => {
                        if (!routes) {
                            routes = {};
                        }
                        routes[appNameInner] = routesCallback;
                        this.lsService.setItem('apiRoutes', routes);
                        callback();
                    });
                }
            };

            const userInfo = this.cookieService.getCookie('userInfo', false, true);
            if (this.cookieService.getCookie('appToken', false, true) && userInfo) {
                if (this.appSettingInfo) {
                    this.appSettingInfo.message = 'Verifying user data';
                    this.appSettingInfo.progress = Math.ceil(((2 / stages) * 100));
                }

                getAppRoutes('adminer', () => {
                    if (this.appSettingInfo) {
                        this.appSettingInfo.message = 'Setting up application';
                        this.appSettingInfo.progress = Math.ceil(((3 / stages) * 100));
                    }

                    setTimeout(() => {
                        settingsObserver.next((new Date()));
                    });
                });
            } else {
                this.authenticateService.logout();
                setTimeout(() => {
                    settingsObserver.next((new Date()));
                });
            }
        };

        afterInitialized();

        return settingsObserver;
    };
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts